<template>
    <b-modal
        v-model="modalShow"
        :title="`${$locale.consultation_host}科とメニューの選択`"
        size="lg"
        static
        ok-only
        ok-title="キャンセル"
        ok-variant="yokumiru-gray"
        @ok="close"
        @hidden="close">
        <div v-if="isLoadedState">
            <div class="row mt-4 mb-4">
                <div class="col">
                    <h6 class="modalHeading">{{ $locale.consultation_host }}科の選択</h6>
                    <div class="input-group">
                        <select
                            v-model="medicalCourse"
                            class="form-control selectMedicalCourse"
                            :class="{ 'is-invalid' : errors.medical_course_id }"
                            @change="onSelectMedicalCourse">
                            <option :value="null">{{ $locale.consultation_host }}科を選択してください</option>
                            <option
                                v-for="course in medicalCourses"
                                :value="course">
                                {{ course.name }}
                            </option>
                        </select>
                    </div>
                </div>
            </div>
            <div class="row mt-4 mb-4">
                <div class="col">
                    <h6 class="modalHeading">メニューの選択</h6>
                    <div v-if="medicalCourse === null">
                        <p class="small text-muted">{{ $locale.consultation_host }}科を選択してください</p>
                    </div>
                    <div
                        v-else-if="doctorMenus !== null"
                        class="doctorMenuList">
                        <template v-if="doctorMenus.length > 0">
                            <template v-for="menu in doctorMenus">
                                <doctor-doctor-menu
                                    :menu="menu"
                                    :user="user"
                                    with-repeatable-date
                                    selectable>
                                </doctor-doctor-menu>
                            </template>
                        </template>
                        <template v-else>
                            <p class="small text-muted">この{{ $locale.consultation_host }}科にはメニューが存在しません</p>
                        </template>
                    </div>
                    <div
                        v-else
                        class="d-flex justify-content-center align-items-center pt-5 pb-5">
                        <b-spinner variant="yokumiru-doctor"></b-spinner>
                    </div>
                </div>
            </div>
        </div>
    </b-modal>
</template>

<script>
    import constants from '../../../constants'
    import { mapMutations } from 'vuex'
    import moment from 'moment-timezone'
    import FPSManager from '../../../FPSManager'

    const fps = new FPSManager({ fps: 1 })

    export default {
        props: {
            doctor: {
                type: Object,
                default: null,
            },
        },

        data: function () {
            return {
                modalShow: false,
                consultationStatus: constants.consultations,
                user: null,
                doctorMemo: '',
                medicalCourses: [],
                medicalCourse: null,
                doctorMenus: null,
                doctorMenu: null,
                frame: null,
                errors: {},
            }
        },

        computed: {
            isLoadedState: function () {
                return this.user !== null
            },
        },

        created: function () {
            this.fetchMedicalCourses()
            bus.$on('open-modal-doctor-reservation-doctor-menu', this.open)
            bus.$on('close-modal-doctor-reservation-doctor-menu', this.close)
            bus.$on('selected-doctor-doctor-menu', this.onSelectDoctorMenu)
        },

        beforeDestroy: function () {
            bus.$off('open-modal-doctor-reservation-doctor-menu')
            bus.$off('close-modal-doctor-reservation-doctor-menu')
        },

        methods: {
            ...mapMutations({
                setRecentlyUserConsultations: 'doctorReservation/setRecentlyUserConsultations',
            }),

            /**
             * モーダル表示
             */
            open: async function () {
                this.modalShow = true

                this.init()
                this.startTimezoneTimer()
                await this.fetchDoctorMemo()
                await this.fetchRecentlyUserConsultations()
            },

            /**
             * モーダル非表示
             */
            close: function () {
                this.modalShow = false
            },

            init: function () {
                this.user = this.$store.state.doctorReservation.user
                this.setDoctorMemo(null)
                this.setDoctorMenu(null)
                this.setMedicalCourse(null)

                this.doctorMemo = ''
                this.doctorMenu = null
                this.doctorMenus = null
                this.medicalCourse = null
            },

            /**
             * 診療科の取得
             */
            fetchMedicalCourses: function () {
                axios.get(constants.doctor.medical_courses.endpoint.base)
                    .then(({data}) => {
                        this.medicalCourses = data
                    })
            },

            /**
             * メニューの取得
             */
            fetchDoctorMenus: function () {
                this.doctorMenus = null
                this.doctorMenu = null

                if (!this.medicalCourse) {
                    this.doctorMenus = []
                    return
                }

                const endpoint = constants.doctor.doctor_menus.endpoint.base

                axios.get(`${endpoint}?medical_course_id=${this.medicalCourse.id}&user_id=${this.user.id}`)
                    .then(({data}) => {
                        this.doctorMenus = data.data
                    })
            },

            /**
             * 医師の会員メモを取得
             */
            fetchDoctorMemo: function () {
                const endpoint = constants.doctor.doctor_memo.endpoint.base

                return axios.get(`${endpoint}/${this.doctor.id}/${this.user.id}`)
                    .then(({data}) => {
                        this.setDoctorMemo(data.doctor_memo)
                        this.doctorMemo = data.doctor_memo
                    })
            },

            /**
             * 直近の会員の相談予約を保持
             * @see https://github.com/sewii/Yokumiru/issues/568
             */
            fetchRecentlyUserConsultations: function () {
                const endpoint = constants.doctor.consultations.endpoint.base
                const query = `?page=1&sort=start_time&desc=true&status=${this.consultationStatus.finished}&user_id=${this.user.id}`

                return axios.get(`${endpoint}${query}`)
                    .then(({data}) => {
                        this.setRecentlyUserConsultations(data.data)
                    })
            },

            /**
             * 予約日時選択モーダル表示
             */
            showModalDoctorReservation: function () {
                bus.$emit('open-modal-doctor-reservation-date-select')
            },

            /**
             * 相談科が選択されたとき
             */
            onSelectMedicalCourse: function () {
                this.setMedicalCourse(this.medicalCourse)
                this.fetchDoctorMenus()
            },

            /**
             * 医師メニューが選択されたとき
             *
             * @param {object} menu
             */
            onSelectDoctorMenu: function (menu) {
                this.setDoctorMenu(menu)
                this.doctorMenu = menu
                this.showModalDoctorReservation()
            },

            /**
             * タイムゾーン表記の現在時刻を進める
             */
            startTimezoneTimer: function() {
                this.frame = requestAnimationFrame(this.startTimezoneTimer)
                fps.tick(this.elapse)
            },

            elapse: function () {
                if (this.doctor) {
                    const timezone = this.doctor.timezone

                    let time = moment().tz(this.doctor.timezone).format('ah:mm')
                    if (time.includes('午前12')) {
                        time = time.replace('午前12', '午前0')
                    }

                    this.setTimezoneWithCurrentTime(`${timezone} (${time})`)
                }
            },

            ...mapMutations({
                setMedicalCourse: 'doctorReservation/setMedicalCourse',
                setDoctorMenu: 'doctorReservation/setDoctorMenu',
                setDoctorMemo: 'doctorReservation/setDoctorMemo',
                setTimezoneWithCurrentTime: 'doctorReservation/setTimezoneWithCurrentTime',
            }),
        },
    }
</script>

<style lang="scss" scoped>
.selectMedicalCourse {
    max-width: 300px;
}

.doctorMenuList {
    .doctorMenu {
        margin-bottom: 15px;
    }
}

.modalHeading {
    margin-bottom: 15px;
    color: #7D868D;
    font-size: 16px;
    font-weight: bold;
}
</style>
